import React, { useEffect, useState } from 'react';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { HiOutlineXMark } from "react-icons/hi2";
import { HiBars3 } from "react-icons/hi2";
import logo from '../images/logo.webp';
import AOS from "aos";
import "aos/dist/aos.css";

import VideoSlider from './VideoSlider';
import FirstSection from './FirstSection';
import PortfolioSection from './PortfolioSection';
import StorySection from './StorySection';
import REviewSection from './REviewSection';
import ProcessSection from './ProcessSection';
import BeforeAfterSection from './BeforeAfterSection';
import ProfileSection from './ProfileSection';
import PriceSection from './PriceSection';
import ComparisonSection from './ComparisonSection';
import FaqsSection from './FaqsSection';

function Home() {
    const [handlebar, sethandlebar] = useState(false);

    useEffect(() => {
        AOS.init({

        });
        window.scrollTo(0, 0)
    }, [])

    useEffect(() => {
        AOS.refresh();
    }, [handlebar]);

    // const handleScroll = (elementId) => {
    //     sethandlebar(!handlebar);
    //     const element = document.getElementById(elementId);
    //     if (element) {
    //         // Calculate the header height or default to 80 if header isn't found
    //         const header = document.querySelector('.header');
    //         const offset = header ? header.offsetHeight : 80;

    //         // Get the element's position relative to the viewport
    //         const elementPosition = element.getBoundingClientRect().top;

    //         // Calculate the scroll position so the element is below the header
    //         const offsetPosition = elementPosition + window.pageYOffset - offset;

    //         // Scroll smoothly to the calculated position
    //         window.scrollTo({
    //             top: offsetPosition,
    //             behavior: "smooth"
    //         });
    //     }
    // };
    const handleScroll = (elementId) => {
        sethandlebar(!handlebar);
        const element = document.getElementById(elementId);

        if (element) {
            // Calculate the header height or default to 80 if header isn't found
            const header = document.querySelector('.header');
            const offset = header ? header.offsetHeight : 80;

            // Get the element's position relative to the viewport
            const elementPosition = element.getBoundingClientRect().top;

            // Check for mobile view (e.g., screen width <= 768px) and adjust scroll behavior
            if (window.innerWidth <= 768) {
                // For mobile, scroll to the element just below the header
                const offsetPosition = elementPosition + window.pageYOffset - 100;

                // Scroll smoothly to the calculated position
                window.scrollTo({
                    top: offsetPosition,
                    behavior: "smooth"
                });
            } else {
                // For desktop, keep the default behavior (scrolling to the element with an offset)
                const offsetPosition = elementPosition + window.pageYOffset - offset;

                // Scroll smoothly to the calculated position
                window.scrollTo({
                    top: offsetPosition,
                    behavior: "smooth"
                });
            }
        }
    };


    return (

        <div style={{ cursor: "default" }}>
            {/*cursor animation */}
            {/* {!isMobile && (
                <AnimatedCursor
                    className="animatedCursor"
                    innerSize={15}
                    outerSize={15}
                    color='254,114,1'
                    outerAlpha={0}
                    innerScale={1}
                    outerScale={15}
                    clickables={[
                        'a',
                        'input[type="text"]',
                        'input[type="email"]',
                        'input[type="number"]',
                        'input[type="submit"]',
                        'input[type="image"]',
                        'label[for]',
                        'select',
                        'textarea',
                        'button',
                        '.link',
                        '.icon-bars',
                    ]}
                />
            )} */}
            {/*Header */}
            <header data-aos="fade-down" data-aos-duration="800" id="header" className='header'>
                <div className={handlebar ? "active headernav" : "headernav"}>
                    <a className='logo' href='#first'>
                        <img alt='logo' src={logo} className='img-fluid' />
                    </a>
                    <div className={handlebar ? "navbar activenav" : "navbar"} >

                        <nav
                            // data-aos="fade-down"
                            // data-aos-duration="800"
                            className={`menu ${handlebar ? "open" : "closed"}`}
                        >
                            <ul >
                                <div className='navbox'>
                                    <div
                                        className="main"
                                        onClick={() => handleScroll('portfolio')}
                                    >
                                        <li className="list">Portfolio</li>
                                    </div>
                                    <div
                                        className="main"
                                        onClick={() => handleScroll('process')}
                                    >
                                        <li className="list">Our Process</li>
                                    </div>
                                </div>
                                <div className='navbox'>
                                    <div
                                        className="main"
                                        onClick={() => handleScroll('service')}
                                    >
                                        <li className="list">Services</li>
                                    </div>
                                    <div
                                        className="main"
                                        onClick={() => handleScroll('client')}
                                    >
                                        <li className="list">Testimonials</li>
                                    </div>
                                </div>
                                <div className='navbox'>
                                    <div
                                        className="main"
                                        onClick={() => handleScroll('faqs')}
                                    >
                                        <li className="list">FAQ</li>
                                    </div>

                                    <a
                                        className="main btnbookcall"
                                        href=" https://calendly.com/sudhanshubatra-designer/quick-meeting"
                                        target='_blank'
                                        rel="noreferrer"
                                        onClick={() => handleScroll('portfolio')}
                                    >
                                        <p>Book call</p>
                                    </a>

                                </div>
                            </ul>

                        </nav>

                    </div>
                    <div className='icon' onClick={() => sethandlebar(!handlebar)}>
                        {
                            handlebar ? <HiOutlineXMark className='icon-bars' /> : <HiBars3 className='icon-bars' />
                        }
                    </div>
                </div>
            </header>

            {/*First section */}

            <FirstSection />
            {/*Portfolio section */}

            <PortfolioSection />

            {/*Our Story Section */}

            <StorySection />
            {/*Review section */}
            <REviewSection />

            {/*process section */}

            <ProcessSection />

            {/*before-after section */}
            <BeforeAfterSection />

            {/*profile section */}


            <ProfileSection />
            {/*service section */}

            <PriceSection />

            {/*comparison section */}

            <ComparisonSection />

            {/*client section */}

            <VideoSlider />
            {/* 
                    <div className='client-main'>
                        <div className="slider-container">
                            <Slider {...settings}>
                                <div>
                                    <div className='slide-box'>
                                        <button className='btn-video'
                                            onClick={() => handleclick(1)}
                                           >
                                            <CiPlay1 />
                                        </button>

                                        <video className='video-box'>
                                            <source src={video1} type='video/mp4' />
                                        </video>
                                    </div>
                                </div>
                                <div>
                                    <div className='slide-box' >
                                        <button className='btn-video' onClick={() => handleclick(2)}
                                           >
                                            <CiPlay1 />
                                        </button>
                                        <video className='video-box'>
                                            <source src={video2} type='video/mp4' />
                                        </video>
                                    </div>
                                </div>
                                <div>
                                    <div className='slide-box'>
                                        <button className='btn-video'
                                            onClick={() => handleclick(3)}
                                            >
                                            <CiPlay1 />
                                        </button>
                                        <video className='video-box'>
                                            <source src={video3} type='video/mp4' />
                                        </video>
                                    </div>
                                </div>
                                <div>
                                    <div className='slide-box'>
                                        <button className='btn-video'
                                            onClick={() => handleclick(4)}
                                           >
                                            <CiPlay1 />
                                        </button>

                                        <video className='video-box'>
                                            <source src={video4} type='video/mp4' />
                                        </video>
                                    </div>
                                </div>
                            </Slider>
                        </div>
                    </div> */}
            {/* <!-- Modal --> */}
            {/* <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                        <div class="modal-dialog modal-dialog-centered">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <button type="button" class="btn-close"
                                        data-bs-dismiss="modal" aria-label="Close"
                                    >
                                        <FaXmark className='icon-close'
                                        // data-bs-dismiss="modal" aria-label="Close"
                                        />
                                    </button>
                                </div>
                                <div class="modal-body">
                                    <div className='model-box'>
                                        {
                                            videosrc === 1 ?
                                                <video className='video-box' controls autoPlay loop>
                                                    <source
                                                        id="videosourceid"
                                                        src={video1}
                                                        type='video/mp4' />
                                                </video>
                                                : ""
                                        }
                                        {
                                            videosrc === 2 ?
                                                <video className='video-box' controls autoPlay loop>
                                                    <source
                                                        id="videosourceid"
                                                        src={video2}
                                                        type='video/mp4' />
                                                </video>
                                                : ""
                                        }
                                        {
                                            videosrc === 3 ?
                                                <video className='video-box' controls autoPlay loop>
                                                    <source
                                                        id="videosourceid"
                                                        src={video3}
                                                        type='video/mp4' />
                                                </video>
                                                : ""
                                        }
                                        {
                                            videosrc === 4 ?
                                                <video className='video-box' controls autoPlay loop>
                                                    <source
                                                        id="videosourceid"
                                                        src={video4}
                                                        type='video/mp4' />
                                                </video>
                                                : ""
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> */}
            {/*faqs section */}
            {/* <h1>Frequently Asked Questions</h1> */}
            <FaqsSection />
        </div>
    )
}

export default Home;
